import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    Position,
    ColumnChooser,
    Paging,
    Pager,
    Form,
    ToolbarItem,
    Editing, HeaderFilter,
    Selection, Scrolling
    , Export, Summary, TotalItem
} from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react/button';
import 'devextreme/data/odata/store';
import CustomStore from 'devextreme/data/custom_store';
import DropDownBox from 'devextreme-react/drop-down-box';
import NumberBox from 'devextreme-react/number-box';
import Request from "../../../components/api/Request";
import './DomainCustomTesvikPersonel.scss';
import { showToast, parseDate, parseApiDate, showDialog } from "../../../utils/Utils";
import { ToastType } from "../../../constants/Constants";
import { custom } from 'devextreme/ui/dialog';
import * as AppActions from '../../../actions/AppActions';

const DomainCustomTesvikPersonel = (props) => {

    const dispatch = useDispatch();

    const listeBasligi = "Personel Teşvik Sorgu Düzenleme Formu";
    const [store, setStore] = useState(null);
    const [tcKimlikNo, setTcKimlikNo] = useState(null); 

    const [storeIslemDurumu, setStoreIslemDurumu] = useState([]);
    const [valueIslemDurumu, setValueIslemDurumu] = useState([]);

     const egitimArray =[ 
        { id: 1, adi: 'Eğitim Belgesi Yoktur' },
        { id: 2, adi: 'Eğitim Belgesi ile Meslek Kodu Uyuşmamaktadır' },
        { id: 4, adi: 'Kalfalık/Ustalık' },
        { id: 5, adi: 'Ortaöğretim(Lise ve Dengi)' },
        { id: 6, adi: 'Yüksek Okul' },
        { id: 7, adi: 'Üniversite' },
        { id: 8, adi: 'İşkur İşgücü Yetiştirme Kursu(Sistem tespit eder)' },
        { id: 9, adi: 'Mesleki Yeterlilik Belgesi(Sistem tespit eder)' },
    ];


    useEffect(() => {
        setStoreIslemDurumu(islemDurumuListYukle());
        setStore(getStore());

    }, [])


    const getStore = () => {
 

        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {


                let filterArr = [];
                filterArr.push({
                    property: "appDomain.id",
                    operator: "=",
                    value: props.data.id,
                    type: "Long"
                })

               let params =   "filter=" + JSON.stringify(filterArr);
                params =encodeURI(params);

                const request = new Request("/domainCustomTesvik/getKayitList?" +params, "GET");
                return request.run()
                    .then(response => {
                        if (response.data) {
                            return response.data.data;
                        } else {
                            return []

                        }
                    });
            }
        });
    }
    const yenile = () => {
        setStore(getStore());
    }

    const kaydet = () => {
 
        if (tcKimlikNo ==null || tcKimlikNo.toString().length != 11 ) {
            showToast('Tckimlik bilgisini kontrol ediniz', ToastType.ERROR, 500);
            return;
        }

        if (valueIslemDurumu ==null) {
            showToast('Eğitim sorgu bilgisini kontrol ediniz.', ToastType.ERROR, 500);
            return;
        }
 
        let data = {
            appDomain:{id:props.data.id} ,
            tcKimlikNo:tcKimlikNo.toString(),
            egitimKodu:valueIslemDurumu.toString(),
            egitimKoduAdi:""
        }

        egitimArray.map(item => {
            if(item.id == valueIslemDurumu){
                data.egitimKoduAdi = item.adi;
            }
        });

        const request = new Request("/domainCustomTesvik/createKayit", "POST", data);
        return request.run()
            .then(response => {
                if (response.data && response.data.data) {
                    setTcKimlikNo(null);
                    setValueIslemDurumu(null);
                    yenile();
                }
            });
    }


    function onTcValueChanged(args) {
        setTcKimlikNo(args.value);
    }
    function onMeslekKoduValueChanged(args) {
        setValueIslemDurumu(args.value);
    } 
    function islemDurumuGrid_onSelectionChanged(e) {
        setValueIslemDurumu(e.selectedRowKeys);
    }

    function islemDurumuGridRender() {
        return (
            <DataGrid
                dataSource={storeIslemDurumu}
                columns={['adi']}
                hoverStateEnabled={true} 
                onSelectionChanged={islemDurumuGrid_onSelectionChanged}>
                <Selection mode="single" />
                <Scrolling mode="virtual" />
                <Paging enabled={true} pageSize={10} />
                <FilterRow visible={true} />
            </DataGrid>
        );
    }

    const islemDurumuListYukle = () => {

        return new CustomStore({
            loadMode: 'raw',
            key: 'id',
            load: function () {

                return egitimArray;
            }
        });

    }

    function deleteDetay(data) {
        let myDialog = custom({
            title: "Silme Uyarı",
            messageHtml: "<b>Seçili kaydı silmek istiyor musunuz?</b>",
            buttons: [{
                text: "Evet",
                onClick: (e) => {
                    return { buttonText: e.component.option("text") }
                }
            }, {
                text: "Hayır",
                onClick: (e) => {
                    return { buttonText: e.component.option("text") }
                }
            },
            ]
        });
        myDialog.show().then((dialogResult) => {
            if (dialogResult.buttonText === 'Evet') {
                let url = "/domainCustomTesvik/deleteKayit/" + data.id;
                const request = new Request(url, "DELETE");
                dispatch(AppActions.setLoading(true, "Silme işlemi yapılıyor.."));
                return request.run()
                    .then(response => {
                        dispatch(AppActions.setLoading(false, ""));
                        if (response.data && response.data.success) {
                            yenile();
                        }
                    });
            }

        });

    }


    return (
        <div >
            <div>
                <React.Fragment>
                    <div className="dx-fieldset">
                        <div className="dx-fieldset-header">{listeBasligi}</div>

                        <div className="dx-field">
                            <div className="dx-field-label">TcKimlikNo</div>
                            <div className="dx-field-value">
                                <NumberBox
                                    value={tcKimlikNo}
                                    readOnly={false}
                                    hoverStateEnabled={false}
                                    onValueChanged={onTcValueChanged} />
                            </div>
                        </div>
                        <div className="dx-field">
                            <div className="dx-field-label">Teşvik Sorgu Seçenek</div>
                            <div className="dx-field-value">
                                <DropDownBox
                                    value={valueIslemDurumu}
                                    valueExpr="id"
                                    deferRendering={false}
                                    displayExpr="adi"
                                    placeholder="İşlem Durumu Seçiniz..."
                                    showClearButton={true}
                                    dataSource={storeIslemDurumu}
                                    onValueChanged={onMeslekKoduValueChanged}
                                    contentRender={islemDurumuGridRender}
                                />
                            </div>
                        </div>
                    </div>

                    <Button
                        icon="plus"
                        width={450}
                        text="Ekle"
                        type={'success'}
                        style={{ fontSize: "15px" }}
                        onClick={kaydet}>

                    </Button>
                </React.Fragment>
            </div>
            <div>
                <DataGrid
                    width="100%"
                    height="350px"
                    dataSource={store}
                    key="id"
                    keyExpr="id"
                    showBorders={true}
                    focusedRowEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode={"widget"}
                    columnAutoWidth={false}
                    selection={{ mode: 'single', deferred: true }}
                >
                    <Column type="buttons" caption={'İşlem'}
                    buttons={[ 
                        {
                            hint: 'Sil', icon: 'remove', 
                            onClick: (e) => { deleteDetay(e.row.data); }
                        } 
                    ]}
                />

                    <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} />
                    <Column dataField="tcKimlikNo" width={110} caption={'Tc'} visible={true} />
                    <Column dataField={'egitimKoduAdi'} minWidth={150} width={90} caption={'Sorgu Bilgi'} />
                </DataGrid>
            </div>

        </div>
    )
}

export default DomainCustomTesvikPersonel;
